// src/utils/installLsPatch.js
import { markLocalChange } from "./gamePersistence";

let installed = false;

export function installLocalStoragePatch() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  const { setItem, removeItem, clear } = window.localStorage;

  window.localStorage.setItem = function patchedSetItem(key, value) {
    const prev = window.localStorage.getItem(key);
    setItem.apply(window.localStorage, [key, value]);
    if (prev !== value) {
      markLocalChange(); // fires WTUFO_DIRTY
    }
  };

  window.localStorage.removeItem = function patchedRemoveItem(key) {
    const had = window.localStorage.getItem(key) != null;
    removeItem.apply(window.localStorage, [key]);
    if (had) {
      markLocalChange();
    }
  };

  window.localStorage.clear = function patchedClear() {
    const len = window.localStorage.length;
    clear.apply(window.localStorage);
    if (len > 0) {
      markLocalChange();
    }
  };
}
